import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Configuration } from './models/configuration';
import { FcmPushService } from './fcm-push.service';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ]
})
export class FcmPushModule {
  public static forRoot(config: Configuration): ModuleWithProviders<any> {
    return {
      ngModule: FcmPushModule,
      providers: [
        FcmPushService,
        {
          provide: 'config',
          useValue: config
        }
      ]
    }
  }
}
